import { render, staticRenderFns } from "./no-results.vue?vue&type=template&id=00c58c2c&"
import script from "./no-results.vue?vue&type=script&lang=ts&"
export * from "./no-results.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports